'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import OptionSelector from './option-selector';

// -----------------------------------------------------------
//  OptionSelectors
// -----------------------------------------------------------
const OptionSelectors = ({options, selected, onChange}) => {
  return (
    <div>
      {
        (options || []).map((option, i) => {
          return <OptionSelector { ...option }
                                 key={ i }
                                 selected={ selected[option.id] }
                                 onChange={ onChange } />;
        })
      }
    </div>
  );
};

export default OptionSelectors;
